import { Camera } from 'lucide-react';

import CTMonitoringFunctionalityDisabled from './CTMonitoringFunctionalityDisabled';
import UIStrings from '@/Utils/UIStrings';

function CTMonitoringWebcamStub() {
    return (
        <CTMonitoringFunctionalityDisabled
            icon={<Camera className="text-muted-foreground size-6" aria-hidden />}
            message={UIStrings.WebcamDisabled}
            className="h-52"
        />
    );
}

export default CTMonitoringWebcamStub;
